import { createSlice } from "@reduxjs/toolkit";


export interface configStateType {
    loading: boolean;
    clientConfig:Record<string, string>;
    clientId: string;
    error: Error | null;
};
const initialState: configStateType = {
    loading: false,
    clientConfig:{},
    clientId: '',
    error: null,
};


export const configStateSlice = createSlice({
    name: "configStateSlice",
    initialState,
    reducers:{
        setClientConfigData:(state,action)=>{
            state.clientConfig=action.payload
        },
        setClietIdData:(state,action)=>{
            state.clientId = action.payload
        }
    }
});

export const{
    setClientConfigData, setClietIdData
}=configStateSlice.actions;

export default configStateSlice.reducer;